import React from 'react';
import { Box, Paper, Typography, Button } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InsightsIcon from '@mui/icons-material/Insights';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const TalentInsightsCard = ({ talent, onPresentClick, hasAnonymisedProfile }) => {
    const cleanedExperience = talent?.experienceTalent
      ?.replace(/^"(.*)"$/, '$1')  
      .trim();

    const resumeIA = cleanedExperience 
      ? cleanedExperience 
      : "Aucun compte-rendu généré pour ce profil.";

      const REQUIRED_FIELDS = [
    // Étape 1
    'nomCandidat',
    'prenomCandidat',
    'email',
    'phone',
    'LinkedIn',
    'cvHash',
  
    // Étape 2
    'poste',
    'posteActuelIntitule',
    'entrepriseActuelle',
    'anneesPoste',
    'experienceGlobale',
    'informationsComplementaires',
    'disponibilite',
  
    // Étape 3
    'niveauEtudes',
    'titre',
    'date',
    'etablissement',
    'experienceTalent',
    'pointsEssentiels',
    'competences',
    'langues',
  
    // Étape 4
    'postesRecherches',
    'secteurRecherche',
    'secteurNonRecherche',
    'typesContrat',
    'remunerations',
    'travailSouhaite',
    'lieuxSouhaites',
    'lieuxNonSouhaites',
    'etatRecherche'
  ];
  
  const calculateNote = (talent) => {
    const totalFields = REQUIRED_FIELDS.length;
  
    const filledCount = REQUIRED_FIELDS.filter(field => {
      const value = talent?.[field];
      if (Array.isArray(value)) return value.length > 0;
      if (value instanceof Map) return value.size > 0;
      return value !== undefined && value !== null && value !== '';
    }).length;
  
    return Math.round((filledCount / totalFields) * 100); 
  };
  
  const noteScore = calculateNote(talent);
  const noteGlobale = `${noteScore}%`;
  const getProgressColor = (score) => {
    if (score < 30) return '#f44336'; 
    if (score < 60) return '#ff9800';
    if (score < 80) return '#ffeb3b'; 
    return '#4caf50';                
  };
  
  return (
    <Paper className="insights-card">
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        {/* <InsightsIcon color="primary" /> */}
        <Typography variant="h6">
          Remplissage du profil
        </Typography>
      </Box>
      {/* <Typography variant="h4" color="primary" mb={2}>
        {noteGlobale}
      </Typography> */}
      <Box width="100%" mb={2}>
        <Box display="flex" justifyContent="space-between" mb={0.5}>
          <Typography variant="body2" color="textSecondary">0%</Typography>
          <Typography variant="body2" color="textPrimary" fontWeight="bold">
            {noteGlobale}
          </Typography>
          <Typography variant="body2" color="textSecondary">100%</Typography>
        </Box>
        <Box
          height={14}
          width="100%"
          borderRadius={7}
          sx={{
            background: `linear-gradient(to right, ${getProgressColor(noteScore)} ${noteScore}%, #e0e0e0 ${noteScore}%)`,
            transition: 'background 0.3s ease',
          }}
        />
      </Box>



      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <AssessmentIcon color="action" />
        <Typography variant="subtitle1">Résumé du profil</Typography>
      </Box>
      <Typography variant="body2" color="textSecondary" mb={2} align="left">
        {resumeIA}  
      </Typography>

      {/* ✅ Message conditionnel */}
      {!hasAnonymisedProfile ? (
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <WarningAmberIcon color="error" />
          <Typography variant="body2" color="error">
            Ce profil n'est pas encore anonymisé. Veuillez générer un profil anonymisé avant de l’envoyer.
          </Typography>
        </Box>
      ) : (
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <CheckCircleIcon color="success" />
          <Typography variant="body2" color="success.main">
            Ce profil est prêt. Vous pouvez le présenter sur une mission.
          </Typography>
        </Box>
      )}

      <Button
        variant="contained"
        color="primary"
        startIcon={<AssignmentTurnedInIcon />}
        fullWidth
        onClick={onPresentClick}
        disabled={!hasAnonymisedProfile}
      >
        Positionner le profil
      </Button>
    </Paper>
  );
};

export default TalentInsightsCard;
